import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { CERConfig } from '@slims/shared/types';
import { DEFAULT_CER_CONFIG } from '@slims/shared/types';

interface CERStore {
	config: Omit<CERConfig, 'id' | 'tenantId'>;
	isLoading: boolean;
	setConfig: (config: Partial<Omit<CERConfig, 'id' | 'tenantId'>>) => void;
	setFullConfig: (config: Omit<CERConfig, 'id' | 'tenantId'>) => void;
	setLoading: (loading: boolean) => void;
}

export const useCERStore = create<CERStore>()(
	immer((set) => ({
		config: { ...DEFAULT_CER_CONFIG },
		isLoading: true,
		setConfig: (partial) =>
			set((state) => {
				Object.assign(state.config, partial);
			}),
		setFullConfig: (config) =>
			set((state) => {
				state.config = config;
				state.isLoading = false;
			}),
		setLoading: (loading) =>
			set((state) => {
				state.isLoading = loading;
			}),
	})),
);
